import {Button} from "@nextui-org/react"; 
import {useNavigate} from "react-router-dom"; 
import {useRef} from "react"; 
const Plan = ({ toDeposit,  styles, investmentAmount, maximumInvestment, monthlyPercentage, dailyPercentage, days}) =>{
    const navigate = useNavigate(); 
    const refPlans = useRef(null); 
    const handleButtonClick = (ev)=>{
        const minimumDeposit = refPlans.current.innerHTML; 
        console.log("checking minimum deposit"); 
        const priceArr = minimumDeposit.split(""); 
        const price = priceArr.slice(1, priceArr.length).join(""); 
        console.log(price); 
        if(toDeposit === true){
            navigate("/deposit");
        }
        else {
            navigate("/signup"); 
        }
    }
    return (
        <>
            <div className ={ `${styles ? styles: ""} border-2 border-blue-600 p-10 flex flex-col items-center  space-x-10 justify-center  rounded-lg px-5`}>
                        <div className = "flex justify-center items-center gap-4">
                            <p className = 'text-blue-700 text-4xl font-bold'> {dailyPercentage}</p>
                            <p className = "text-xl font-medium"> Daily</p>
                        </div>
                        <p className = ' py-[3%] text-center font-bold text-2xl capitalize'>{days}</p>
                        <div>
                            <p className = "font-medium" ref = {refPlans}>{`Minimum investment: $${investmentAmount}`}</p>
                            <p className = "font-medium">{`Maximum investment: $${maximumInvestment}`}</p>
                            <p className = 'font-medium'>{`Average Monthly: ${monthlyPercentage}`}</p>
                        </div>
                        <Button className = "my-4 justify-self-center self-center text-white bg-blue-600 px-10" onClick = {handleButtonClick}> Deposit </Button>
                </div>
        </>
    ); 
}
export default Plan; 
